import {
  React,
  Component,
  PropTypes
} from 'imports/CommonImports';

import {
  SuccessColorLight,
} from 'imports/DesignImports';

import {
  PercentageCircle
} from 'imports/ComponentsImports';

import {
  Paper,
  SelectField,
  MenuItem,
  CircularProgress,
} from 'material-ui';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '20em',
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '1em',
  },
  header: {
    marginLeft: '1em',
  }
}

class PercentageIndex extends Component {
  constructor(props){
    super(props);
    var yearlyValues = props.yearlyValues.map((value, i) => {return {value: value.value, year: value.year, position: i} })
    this.state = {
      yearlyValues: yearlyValues,
      value: yearlyValues[0].value,
      selectedMenu: 0,
      years: this.props.years
    }
  }
  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
        <p style={styles.header}><b>{this.props.header} año {this.state.yearlyValues[this.state.selectedMenu].year}</b></p>
        <SelectField value={this.state.selectedMenu} onChange={this.changeSelector} underlineStyle={{display: 'none'}}>
          {this.state.years.map((year, i) =>  <MenuItem key={year} value={year} primaryText={year.toString()}/>)}
        </SelectField>
        </div>
        <div style={styles.valueContainer}>
          <PercentageCircle color={SuccessColorLight} percent={parseFloat(this.state.value)} radius={55} borderWidth={5}/>
        </div>
      </Paper>
    );
  }

  changeSelector = (event, index, value) => {
    var object = this.state.yearlyValues[index]
    this.setState({
      value: object.value,
      selectedMenu: object.position
    })
  }
}

PercentageIndex.propTypes = {
  style: PropTypes.object,
  yearlyValues: PropTypes.array,
}

PercentageIndex.defaultProps = {
  style: {},
  yearlyValues: [
    {year: (new Date(Date.now())).getFullYear() - 1, value: 0},
    {year: (new Date(Date.now())).getFullYear(), value: 0},
    {year: (new Date(Date.now())).getFullYear() + 1, value: 0},
  ]
}

export default PercentageIndex;



// WEBPACK FOOTER //
// ./src/components/dashboard/PercentageIndex.js